import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'
import { STORE_MAP } from '@/config/cache/cache-engine'

export default {
	getLandsCadastralCases: {
		useCache: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].GET_LANDS_CADASTRAL_CASES,
	},
	getBaseLandsCadastralCases: {
		useCache: true,
		cacheStorage: STORE_MAP.BASE,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].GET_LANDS_CADASTRAL_CASES,
	},
	getExtendLandsCadastralCases: {
		useCache: true,
		cacheStorage: STORE_MAP.EXTENDED,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].GET_LANDS_CADASTRAL_CASES,
	},
	getLandsCadastralCase: {
		isSingleCachedEntity: true,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].GET_LANDS_CADASTRAL_CASE,
	},
	createLandsCadastralCase: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].CREATE_LANDS_CADASTRAL_CASE,
	},
	putLandsCadastralCase: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].PUT_LANDS_CADASTRAL_CASE,
	},
	patchLandsCadastralCase: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].PATCH_LANDS_CADASTRAL_CASE,
	},
	deleteLandsCadastralCase: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].DELETE_LANDS_CADASTRAL_CASE,
	},
	getLandsCadastralCasePreview: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].GET_LANDS_CADASTRAL_CASE_PREVIEW,
	},
	getLandsCadastralCasePopup: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].GET_LANDS_CADASTRAL_CASE_POPUP,
	},
}
